export const experienceData = [
  {
    title: "Full-stack Developer",
    company: "Readya",
    date: "2026 - 2026/5",
  },
  {
    title: "Front-End Developer",
    company: "Kan-guroo",
    date: "2025 - 2026/04",
  },
  {
    title: "Back-End / AI Developer",
    company: "Breneo",
    date: "2025 - 2026/04",
  },
  {
    title: "Freelancer",
    company: "Upwork",
    date: "2025 - 2026/02",
  },
  {
    title: "Manager",
    company: "Tegeta Motors",
    date: "2023 - 2024",
  },
];
